<template>
    <div class="flex jc:left gap:8 scroll-margin-top:16 {hidden}_.loading {d:inline-block}[loading]_.loading {@fade|2s|infinite}[loading]_article>p">
        <img alt="" class="r:20 b:0.5px|solid|gray300" height="40" src="images/avatar_logo.jpg" width="40" />
        <article class="ai flex px:24 lh:24px py:16 bg:y50 flex-grow:1 r:28 mr:92@md text:justify">
            <p>
                <span class="loading">UniAI 回答中...🖊️</span>
                <slot></slot>
            </p>
        </article>
    </div>
</template>
